module.exports = __webpack_public_path__ + "img/COMBO TWIRL GREEN.991a17a.svg";